<template>
    <div v-if="!feedbackSent">

        <div class="mt-3">
            <div class="text-align--center">
                <p class="mb-2">Ole ystävällinen ja anna palautetta toimintamallistamme. Palaute menee järjestelmän ylläpitäjälle.</p>
                <label>Oliko tämä palvelu mielestäsi hyvin toteutettu ja toisaalta sinulle hyödyllinen?</label>

                <label class="form-check-inline mr-1" for="sad"><i class="fa fa-frown-o fa-2x" aria-hidden="true"></i></label>

                <div class="d-inline" v-for="i in 11" :key="i">
                    <input class="form-check-input" type="radio" name="helppous" :id="'helppous--' + (i - 1) " v-model="helppous" :value="i - 1">
                    <label class="form-check-inline mr-1" :for="'helppous--' + (i - 1)">{{i - 1}}</label>
                </div>

                <label class="form-check-inline mr-1" for="smile"><i class="fa fa-smile-o fa-2x" aria-hidden="true"></i></label>
            </div>
            <div class="form-group my-3">
                <label for="palaute">Palautteesi</label>
                <textarea class="form-control" name="palaute" id="palaute" rows="3" v-model="feedback"></textarea>
            </div>
            <p>Jos haluat, että sinuun otetaan yhteyttä, niin lisääthän yhteystietosi palautteen mukaan.</p>
            <div class="form-group row">
            <div class="col-sm-6">
            <label for="etunimi">Etunimi</label>
            <input type="text" class="form-control" name="etunimi" id="etunimi" v-model="firstName">
            </div>

            <div class="col-sm-6">
            <label for="sukunimi">Sukunimi</label>
            <input type="text" class="form-control" name="sukunimi" id="sukunimi" v-model="lastName">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-6">
            <label for="puhelinnumero">Puhelinnumero</label>
            <input type="text" class="form-control" name="puhelinnumero" id="puhelinnumero" v-model="phone">
            </div>

            <div class="col-sm-6">
            <label for="email">Sähköposti</label>
            <input type="email" class="form-control" name="email" id="email" v-model="email">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
            <div class="checkbox">
                <input type="checkbox" name="yhteydenotto" id="yhteydenotto" value="kyllä" v-model="contact">
                <label for="yhteydenotto">Pyydän ottamaan yhteyttä.</label>
            </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse mt-2">
            <button class="btn btn-t1-primary" @click="sendForm()">Lähetä</button>
        </div>
        </div>
    </div>
    <div class="mt-5 text-align--center" v-else>
        <h2 class="mb-4">Kiitos.</h2>
        <div class='intro'>
            Palautteenne on nyt lähetetty. Tästä pääset jatkamaan surffailua <a href="https://toyota.fi">Toyota.fi:llä</a>.
        </div>
    </div>
</template>

<script>
import Axios from "axios";
import CONF from "../config";
export default {
  data() {
    return {
      helppous: null,
      feedback: "",
      contact: false,
      feedbackSent: false
    };
  },
  computed: {
    firstName: {
      get() {
        return this.$store.state.form.form.firstName;
      },
      set(value) {
        this.$store.commit("setFirstName", value);
      }
    },
    lastName: {
      get() {
        return this.$store.state.form.form.lastName;
      },
      set(value) {
        this.$store.commit("setLastName", value);
      }
    },
    email: {
      get() {
        return this.$store.state.form.form.email;
      },
      set(value) {
        this.$store.commit("setEmail", value);
      }
    },
    phone: {
      get() {
        return this.$store.state.form.form.phone;
      },
      set(value) {
        this.$store.commit("setPhone", value);
      }
    }
  },
  methods: {
    sendForm() {
      // eslint-disable-next-line
      let data = {
        helppous: this.helppous,
        feedback: this.feedback,
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        email: this.email,
        contact: this.contact
      };

      Axios.post(CONF.apiUrl + "feedback", data)
        .then(r => {
          if (r.status === 201) {
            this.feedbackSent = true;
          }
        })
        .catch(e => window.console.error(e));
    }
  }
};
</script>

<style>
</style>
